"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18N = void 0;
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var PermissionGranted_1 = __importDefault(require("../../../Icons/Notifications/PermissionGranted"));
var config_1 = require("../../../../config");
var AccessRestoredIcon_1 = __importDefault(require("../../../Icons/Notifications/AccessRestoredIcon"));
var utils_1 = require("../../utils");
var WORLDS_COLLABORATOR_URL = "".concat(config_1.config.get('BUILDER_URL'), "/worlds?tab=collaborator");
var WORLD_WITH_REALM_URL = "".concat(config_1.config.get('EXPLORER_URL'), "?realm=");
exports.i18N = {
    en: {
        title: 'World Permission Granted',
        accessTitle: 'World Access',
        access: 'You have been given permission to access World {world}',
        deployment: 'You have been granted deployer permission to World {world}',
        streaming: 'You have been granted streamer permission to World {world}'
    },
    es: {
        title: 'Permiso para mundo otorgado',
        accessTitle: 'Acceso a Mundo',
        access: 'Te han dado permiso para acceder al mundo {world}',
        deployment: 'Te han otorgado permiso de deployar al mundo {world}',
        streaming: 'Te han otorgado permiso de trasmitir en el mundo {world}'
    },
    zh: {
        title: '获得世界许可',
        accessTitle: '世界访问',
        access: '您已获得访问世界的许可 {world}',
        deployment: '您已被授予部署者的许可 {world}',
        streaming: '您已获得流媒体的许可 {world}'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var WorldsPermissionGrantedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    var permission = notification.metadata.permissions[0]; // for now only one permission is allowed per notification
    var isAccessNotification = permission === 'access';
    var world = notification.metadata.world;
    var Icon = isAccessNotification ? AccessRestoredIcon_1.default : PermissionGranted_1.default;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(Icon, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, isAccessNotification ? exports.i18N[locale].accessTitle : exports.i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, (0, utils_1.replaceWithValues)(exports.i18N[locale][permission], {
            world: (react_1.default.createElement("a", { href: isAccessNotification
                    ? "".concat(WORLD_WITH_REALM_URL).concat(world)
                    : WORLDS_COLLABORATOR_URL, className: "dcl notification-link", target: "_blank" }, world))
        }))));
};
exports.default = WorldsPermissionGrantedNotification;
